import React, { useCallback, useRef, useState } from 'react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';

export function useConfirm() {
  const [opts, setOpts] = useState(null);
  const resolver = useRef(null);
  const confirm = useCallback((o) => new Promise((res) => { resolver.current = res; setOpts(o); }), []);
  const done = (v) => { resolver.current?.(v); setOpts(null); };
  const dialog = (
    <AlertDialog open={!!opts} onOpenChange={(v) => !v && done(false)}>
      <AlertDialogContent data-testid="confirm-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle>{opts?.title}</AlertDialogTitle>
          {opts?.text && <AlertDialogDescription>{opts.text}</AlertDialogDescription>}
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={() => done(false)} data-testid="confirm-dialog-cancel">Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={() => done(true)} className={opts?.danger ? 'bg-rose-600 hover:bg-rose-700' : ''} data-testid="confirm-dialog-ok">
            {opts?.ok || 'Confirm'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
  return [dialog, confirm];
}
